export class InputMode
{
	static Decimal = 'decimal'
	static Email = 'email'
	static None = 'none'
	static Numeric = 'numeric'
	static Search = 'search'
	static Tel = 'tel'
	static Text = 'text'
	static Url = 'url'
}